/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	GetTrialsParams,
	GetViolationsParams,
	PraetoidError,
	TrialsResponse,
	ViolationsResponse
} from '../models';

/**
 * Returns all trials
 * @summary Get all trials
 */
export const getTrials = (params?: GetTrialsParams) => {
	return customInstance<TrialsResponse>({ url: `/sync/trials`, method: 'GET', params });
};

export const getGetTrialsQueryKey = (params?: GetTrialsParams) => {
	return ['sync', 'trials', ...(params ? [params] : [])] as const;
};

export const getGetTrialsQueryOptions = <
	TData = Awaited<ReturnType<typeof getTrials>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetTrialsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrials>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetTrialsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrials>>> = () => getTrials(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getTrials>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrialsQueryResult = NonNullable<Awaited<ReturnType<typeof getTrials>>>;
export type GetTrialsQueryError = ErrorType<PraetoidError>;

export function useGetTrials<
	TData = Awaited<ReturnType<typeof getTrials>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | GetTrialsParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrials>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getTrials>>,
					TError,
					Awaited<ReturnType<typeof getTrials>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTrials<
	TData = Awaited<ReturnType<typeof getTrials>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetTrialsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrials>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getTrials>>,
					TError,
					Awaited<ReturnType<typeof getTrials>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTrials<
	TData = Awaited<ReturnType<typeof getTrials>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetTrialsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrials>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all trials
 */

export function useGetTrials<
	TData = Awaited<ReturnType<typeof getTrials>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetTrialsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrials>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTrialsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns violations for a single trial in the authenticated environment
 * @summary Get violations for a trial
 */
export const getSyncTrialViolations = (trialId: string) => {
	return customInstance<ViolationsResponse>({
		url: `/sync/trials/${trialId}/violations`,
		method: 'GET'
	});
};

export const getGetSyncTrialViolationsQueryKey = (trialId: string) => {
	return ['sync', 'trials', trialId, 'violations'] as const;
};

export const getGetSyncTrialViolationsQueryOptions = <
	TData = Awaited<ReturnType<typeof getSyncTrialViolations>>,
	TError = ErrorType<PraetoidError>
>(
	trialId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncTrialViolations>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSyncTrialViolationsQueryKey(trialId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncTrialViolations>>> = () =>
		getSyncTrialViolations(trialId);

	return { queryKey, queryFn, enabled: !!trialId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getSyncTrialViolations>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSyncTrialViolationsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getSyncTrialViolations>>
>;
export type GetSyncTrialViolationsQueryError = ErrorType<PraetoidError>;

export function useGetSyncTrialViolations<
	TData = Awaited<ReturnType<typeof getSyncTrialViolations>>,
	TError = ErrorType<PraetoidError>
>(
	trialId: string,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncTrialViolations>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncTrialViolations>>,
					TError,
					Awaited<ReturnType<typeof getSyncTrialViolations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncTrialViolations<
	TData = Awaited<ReturnType<typeof getSyncTrialViolations>>,
	TError = ErrorType<PraetoidError>
>(
	trialId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncTrialViolations>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSyncTrialViolations>>,
					TError,
					Awaited<ReturnType<typeof getSyncTrialViolations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSyncTrialViolations<
	TData = Awaited<ReturnType<typeof getSyncTrialViolations>>,
	TError = ErrorType<PraetoidError>
>(
	trialId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncTrialViolations>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get violations for a trial
 */

export function useGetSyncTrialViolations<
	TData = Awaited<ReturnType<typeof getSyncTrialViolations>>,
	TError = ErrorType<PraetoidError>
>(
	trialId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getSyncTrialViolations>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetSyncTrialViolationsQueryOptions(trialId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all violations
 * @summary Get all violations
 */
export const getViolations = (params?: GetViolationsParams) => {
	return customInstance<ViolationsResponse>({ url: `/sync/violations`, method: 'GET', params });
};

export const getGetViolationsQueryKey = (params?: GetViolationsParams) => {
	return ['sync', 'violations', ...(params ? [params] : [])] as const;
};

export const getGetViolationsQueryOptions = <
	TData = Awaited<ReturnType<typeof getViolations>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetViolationsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getViolations>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetViolationsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getViolations>>> = () =>
		getViolations(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getViolations>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetViolationsQueryResult = NonNullable<Awaited<ReturnType<typeof getViolations>>>;
export type GetViolationsQueryError = ErrorType<PraetoidError>;

export function useGetViolations<
	TData = Awaited<ReturnType<typeof getViolations>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | GetViolationsParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getViolations>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getViolations>>,
					TError,
					Awaited<ReturnType<typeof getViolations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetViolations<
	TData = Awaited<ReturnType<typeof getViolations>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetViolationsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getViolations>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getViolations>>,
					TError,
					Awaited<ReturnType<typeof getViolations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetViolations<
	TData = Awaited<ReturnType<typeof getViolations>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetViolationsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getViolations>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all violations
 */

export function useGetViolations<
	TData = Awaited<ReturnType<typeof getViolations>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetViolationsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getViolations>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetViolationsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
